import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Section } from '../models/section.model';

@Component({
  selector: 'app-section-navigator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './section-navigator.component.html',
  styleUrls: ['./section-navigator.component.scss'],
})
export class SectionNavigatorComponent {
  @Input() sections: Section[] = [];

  navigateToSection(sectionId: string): void {
    // Find the section element by ID
    const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);

    if (sectionElement) {
      sectionElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }
}
